import { cloneDeep } from "lodash";

export const findCurrentObj = (id, collection) => {
  return collection?.find((el) => el?.id === id);
};

export const isValueInObjIsEmpty = (arr, val) => {
  if (typeof val === "string") {
    return arr.every((el) => el[val] === "" || el[val] === null);
  }
  if (typeof val === "number")
    return arr.every((el) => el[val] === 0 || el[val] === null);
};

export const mapObject = (obj, fn) =>
  Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]));

export const delDoublesWithVal = (arr: any[], val: string) => {
  return arr.reduce((acc, item) => {
    const index = acc.findIndex((el) => el[val] === item[val]);
    if (!~index) {
      acc.push(item);
      if (~index) {
        acc.splice(index, 1);
      }
    }
    return acc;
  }, []);
};

export const objectIsEmpty = (obj: unknown) => Object?.keys(obj)?.length === 0;

export const intersectionOfArrays = (
  arr: object[],
  intersectionArr: any[],
  propertyIntersection: string,
  propertyOfArr: string,
) => {
  const newArr = [];

  if (arr?.length > 0) {
    arr.forEach((el) => {
      for (let i = 0; i <= intersectionArr?.length; i++) {
        if (
          intersectionArr[i]?.[propertyIntersection] === el?.[propertyOfArr]
        ) {
          newArr.push(el);
          break;
        }
        continue;
      }
    });
  }
  return newArr;
};

export const mapDeclarationNestedArray = (initialValues, arrayKey) => {
  return (item) => {
    const index = initialValues[arrayKey]?.findIndex(
      (initItem) =>
        initItem?.column1?.replaceAll(" ", "") ===
        item?.column1?.replaceAll(" ", ""),
    );

    const value = index >= 0 && initialValues[arrayKey]?.splice(index, 1)[0];
    return { ...item, column3: value?.column3 ?? null };
  };
};

export const mapPaymentInfoArray = (initialValues, arrayKey) => {
  return (item) => {
    const index = initialValues[arrayKey]?.findIndex(
      (initItem = { column1: "", column2: "" }) =>
        initItem?.column1?.replaceAll(" ", "") ===
        item?.column1?.replaceAll(" ", ""),
    );
    const value = initialValues[arrayKey]?.splice(index, index > -1 ? 1 : 0)[0];
    return { ...item, column2: value?.column2 ?? "" };
  };
};

export const isObject = (value) => {
  return !Array.isArray(value) && typeof value === "object" && value !== null;
};

export const getValueFromObject = (
  key: string,
  obj: { [key: string]: any },
) => {
  if (typeof key === "string") {
    const keys = key.split(".");
    let result = cloneDeep(obj);
    keys.forEach((elKey) => {
      if (result[elKey]) {
        result = result[elKey];
      }
    });
    return result;
  }
};
